module.exports = __webpack_public_path__ + "img/logo.bd711b98.png";